import { mixpanelTrack } from "./mixpanelTrack";

// Front-page client-side Mixpanel events. Every interaction the front page
// tracks is a pure-client one (opening a content card, opening the favorites
// picker, jumping to a listing page), so nothing here has a server-side home.
//
// Mirrors events/squadBuilderMixpanel.ts: routes through the shared
// mixpanelTrack helper, a SECTION constant, and one track* fn per event.
//
// The signup gate behind the favorites picker is NOT tracked here — it calls
// storeSignupContext("choose_club_country") so the backend fires user_signed_up
// with that context on first-time login (see events/signupTracking.ts).

const SECTION = "Front Page";

export type FrontPageSubsection = "Trending" | "New" | "For You";

/**
 * The front page only ever renders players, evo players and SBCs. (The wider
 * tracking plan also has an "evolution" content type — evolution chains — but
 * no front-page feed shows one.)
 */
export type FrontPageContentType = "player" | "evo_player" | "sbc";

/** The `context` the backend stamps on user_signed_up for this gate. */
export const CHOOSE_CLUB_COUNTRY_SIGNUP_CONTEXT = "choose_club_country";

export const trackViewContent = (params: {
  subsection: FrontPageSubsection;
  content_type: FrontPageContentType;
  /** Whether the card carries a NEW tag (Player.newPlayer). */
  new_content?: boolean;
}) => {
  mixpanelTrack("view_content", {
    section: SECTION,
    subsection: params.subsection,
    content_type: params.content_type,
    new_content: params.new_content ?? false,
    action_type: "core",
  });
};

export const trackChooseClubCountry = () =>
  mixpanelTrack("choose_club_country", {
    section: SECTION,
    subsection: "For You",
    action_type: "user_investment",
  });

export const trackExplore = (params: {
  destination_section: string;
  destination_subsection: string;
  subsection: FrontPageSubsection;
}) =>
  mixpanelTrack("explore", {
    section: SECTION,
    subsection: params.subsection,
    source: "view all",
    destination_section: params.destination_section,
    destination_subsection: params.destination_subsection,
    // The View All button carries no NEW tag of its own.
    new_content: false,
    action_type: "browse",
  });
